import { Visibility, VisibilityOff } from '@mui/icons-material';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import { ValidationErrorType } from 'hooks/useForm';
import useToggle from 'hooks/useToggle';

type PasswordFieldProps = {
    value?: unknown;
    onChange?: React.ChangeEventHandler<HTMLInputElement>;
    error?: ValidationErrorType;
    required?: boolean;
    label: string;
    placeholder: string;
};

const PasswordField = ({ value, onChange, error, label, placeholder, required = true }: PasswordFieldProps) => {
    const [showPassword, toggle] = useToggle();
    return (
        <TextField
            value={value}
            label={label}
            placeholder={placeholder}
            required={required}
            type={showPassword ? 'text' : 'password'}
            size="medium"
            error={!!error}
            helperText={error?.errorMessage}
            InputProps={{
                endAdornment: (
                    <InputAdornment position="end">
                        <IconButton aria-label="toggle password visibility" onClick={toggle}>
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                    </InputAdornment>
                ),
            }}
            onChange={onChange}
        />
    );
};
export default PasswordField;
